import { InputDatePicker } from '@insurance/components'
import { useValidationsField } from '@insurance/hooks'
import { getEffectiveDateRange } from '@insurance/utils'
import { Form } from 'antd'
import dayjs from 'dayjs'
import { useTranslation } from 'react-i18next'

import { useCmrInsuranceValues } from './CmrInsuranceContext'
import { formProps } from './utils'

export const ValidFrom = () => {
  const { t } = useTranslation()
  const { validFromProps, effectiveDateProps } = formProps(t)
  const { required, minDate } = useValidationsField()
  const { isEditable, order } = useCmrInsuranceValues()

  const effectiveDateRange = getEffectiveDateRange(order)

  return isEditable ? (
    <Form.Item {...effectiveDateProps} rules={[required]}>
      <InputDatePicker
        minDate={effectiveDateRange.minDate}
        maxDate={effectiveDateRange.maxDate}
        allowClear={false}
      />
    </Form.Item>
  ) : (
    <Form.Item {...validFromProps} rules={[required, minDate(dayjs())]}>
      <InputDatePicker minDate={dayjs()} placeholder={validFromProps.label} />
    </Form.Item>
  )
}
